module.exports = __webpack_public_path__ + "static/media/drop-slide-thumb-6.afd378ac.png";